import { ExportFormat } from '@ecosystem/newron-client-lib';
import { Filters } from '@utils/pageConfig/Types';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { PerformanceAnalysisView } from '@components/performance-analysis-card/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';

export enum ExportTrackingEvent {
  ExportIconClicked = 'Export icon clicked',
  ExportDataDownloaded = 'Export data downloaded',
}

// Add the other page for tracking in future here
export enum ExportTrackingPage {
  PerformanceAnalysis = 'Performance Analysis',
  CategoryLeaderboard = 'Category Leaderboard',
  OpportunityReview = 'Opportunity Review',
}

export enum ExportTrackingFormat {
  Excel = 'Excel',
  Powerpoint = 'Powerpoint',
  Png = 'Png',
}

// Add the page view for different charts / table in future here
export enum ExportTrackingPageView {
  LineChart = 'Line Chart View',
  StackedChart = 'Stacked Chart View',
  Table = 'Table View',
  BarChart = 'Bar Chart View',
  BubbleChart = 'Bubble Chart View',
  Unknown = 'Unknown View',
}

export interface ExportTrackingParams {
  appliedFilters: Filters[];
  comparisonPeriod: RelativePeriod;
  timeFrame: Periodicity;
}

export const getExportTrackingFormat = (exportFormat: ExportFormat): ExportTrackingFormat => {
  switch (exportFormat) {
    case ExportFormat.Xlsx:
      return ExportTrackingFormat.Excel;
    case ExportFormat.Pptx:
      return ExportTrackingFormat.Powerpoint;
    case ExportFormat.Png:
      return ExportTrackingFormat.Png;
    default:
      throw new Error('Invalid export format');
  }
};

export const getExportTrackingTags = (
  channel: string,
  comparisonPeriod: RelativePeriod,
  pageName: string,
  pageView: ExportTrackingPageView,
  periodType: Periodicity,
) => {
  return {
    channelApplied: channel,
    comparisonPeriodApplied: comparisonPeriod,
    pageName: pageName,
    pageView: pageView,
    timeFrameApplied: periodType,
    productFilterApplied: [], // Follow newron
    productFilterOptionChosen: [], // Follow newron
  };
};

export const getExportChannelApplied = (selectedFilters: Filters[]): string => {
  const defaultChannelApplied = 'All';
  const channelSelectedFilters = selectedFilters.filter((filter) => filter.dataType === 'Channel');

  if (channelSelectedFilters && channelSelectedFilters.length > 0) {
    const channelApplied = channelSelectedFilters.map((selectedFilter) =>
      selectedFilter.options.map((option) => option.label),
    );

    return channelApplied.toString();
  }

  return defaultChannelApplied;
};

// Add more views for other charts in future
export const getPerformanceAnalysisExportTrackingView = (currentView: PerformanceAnalysisView) => {
  if (currentView === PerformanceAnalysisView.LineChart) {
    return ExportTrackingPageView.LineChart;
  }

  return ExportTrackingPageView.Unknown;
};
